import { Provider } from "@redotech/redo-model/order";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getIntegrationsByTeam = {
  name: "getIntegrationsByTeam" as const,
  input: z.object({}),
  output: z.array(createEnum(Provider)),
};
